import React, { useEffect } from "react";
import ResetPasswordComp from "../Components/ResetPassword/ResetPassword";

const ResetPassword = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <ResetPasswordComp />;
};

export default ResetPassword;
